import React, { Component } from "react"
import classnames from "classnames"
import EgiftHeader from "./EgiftHeader"
import EgiftFooter from "./EgiftFooter"
import ModalRoot from "../components/modal/ModalRoot"

class EgiftLayout extends Component {
	render() {
		const { ...props } = this.props
		return (
			<div className="egift-layout">
				<EgiftHeader />
				<main id="egift-body" className={classnames("container-fluid")}>
					{this.props.children}
				</main>
				<ModalRoot />
				<EgiftFooter {...props} />
			</div>
		)
	}
}

export default EgiftLayout



// WEBPACK FOOTER //
// ./src/views/layout/EgiftLayout.js